import { EnvironmentBase } from 'src/environments/environment.base';

class EnvironmentStage extends EnvironmentBase {
}

export const environment = new EnvironmentStage();
